import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './root-reducer';
import rootSaga from './root-saga';

const sagasMiddleware = createSagaMiddleware();
const middlewares = [sagasMiddleware];

if (process.env.NODE_ENV === 'development') {
  // middlewares.push(logger);
}

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middlewares)));

const persistor = persistStore(store);
sagasMiddleware.run(rootSaga);

export { store, persistor };
